<div
  class="dialog-titles"
  [style.color]="tab().color"
  [style.backgroundColor]="tab().backgroundColor"
>
  <h2 class="title dialog-main-title">
    {{ tab().title }}
  </h2>
  @if (!!tab().subtitle) {
    <div class="title dialog-subtitle">
      {{ tab().subtitle }}
    </div>
  }
</div>

<div class="form-container">
  <b2c-input
    class="barcode-input"
    inputMode="numeric"
    [numericOnly]="true"
    [ngModel]="barcode()"
    [ariaLabel]="tab().inputPlaceholder"
    [placeholder]="tab().inputPlaceholder"
    (keydown.enter)="onSubmit()"
    (ngModelChange)="onBarcodeChange($event)"
  />
  <!-- Disabled only while the field is empty (focus is then in the input, so
  no focused button ever gets disabled under the user). Never disabled while
  checking: toggling `disabled` on a focused button drops keyboard focus out
  of the dialog, and the loading swap would leave the button without an
  accessible name. onSubmit() guards re-entry instead. -->
  <b2c-button
    class="submit-btn"
    data-cy="manual_check_btn"
    [styles]="buttonStyles()"
    [disabled]="barcode().length === 0"
    (click)="onSubmit()"
  >
    {{ tab().submitButtonLabel }}
  </b2c-button>
</div>

<!-- The live region exists from first render: content inserted into an
already-present aria-live region is announced; a region inserted together with
its content is not. -->
<div class="check-result" role="status" [attr.aria-busy]="isChecking()">
  @if (hasSubmitted()) {
    @let result = product();
    <div class="result-container" [class.checking]="isChecking()">
      @if (isChecking()) {
        <div class="loader" aria-hidden="true"></div>
        @if (tab().checkingMessage) {
          <div class="result-label">{{ tab().checkingMessage }}</div>
        }
        <div class="code">{{ checkedBarcode() }}</div>
      } @else if (result) {
        <div class="result-label found">
          {{ tab().successMessage }}
        </div>
        <div class="code" data-cy="manual_result_label">
          {{ result.label }}
        </div>
        <div class="code" data-cy="manual_result_code">
          {{ result.barcodeNumber }}
        </div>
      } @else if (checkFailed()) {
        <div class="result-label not-found" data-cy="manual_result_failure">
          {{ tab().failureMessage }}
        </div>
        <div class="code">{{ checkedBarcode() }}</div>
      } @else {
        <div class="result-label not-found" data-cy="manual_result_error">
          {{ tab().errorMessage }}
        </div>
        <div class="code">{{ checkedBarcode() }}</div>
      }
    </div>
  }
</div>
